<template>
  <div class="card card-small" v-if="fetched">
    <div class="card-body p-0 pb-3 text-center">
      <table class="table mb-0 responsive-table">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0 align-middle">Data przelewu</th>
            <th scope="col" class="border-0 align-middle">Kwota</th>
            <th scope="col" class="border-0 align-middle">Typ</th>
            <th scope="col" class="border-0 align-middle">Odbiorca</th>
            <th scope="col" class="border-0 align-middle">Numer konta</th>
            <th scope="col" class="border-0 align-middle">Tytuł przelewu</th>
            <th scope="col" class="border-0 align-middle">Wraunki uruchomienia</th>
            <th scope="col" class="border-0 align-middle action-cell">Akcje</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(instructions, index) in instructionsList"
            :key="instructions.id">
            <td>
              <dt>Data przelewu</dt>
              <dd>{{ instructions.transfer_date }}</dd>
              <div
                v-if="!instructions.transfer_execution_date"
                class="button-date-wrapper">
                <d-button style="width: 100%;">
                  <i class="material-icons">add</i>&nbsp;Wypłać
                </d-button>
                <ss-date
                  @picked="executeInstruction(index)"
                  type="text"
                  name="transfer_execution_date"
                  v-model="selected_execute_date"
                  placeholder=""/>
              </div>
              <dd
                v-if="instructions.transfer_execution_date"
                class="small">
                Zrealizowano:<br />{{ instructions.transfer_execution_date }}
              </dd>
            </td>
            <td>
              <dt>Kwota</dt>
              <dd>{{ toNumber(instructions.amount) }} zł</dd>
            </td>
            <td>
              <dt>Typ</dt>
              <dd>
                {{ instructions.provision_transfer ? transfer_types_lang[instructions.provision_transfer] : '' }}
              </dd>
            </td>
            <td>
                <dt>Odbiorca</dt>
                <dd>{{ instructions.recipient }}</dd>
            </td>
            <td>
              <dt>Numer konta</dt>
              <dd>{{ instructions.account_number }}</dd>
            </td>
            <td>
              <dt>Tytuł przelewu</dt>
              <dd>{{ instructions.transfer_title }}</dd>
            </td>
            <td>
              <dt>Warunki uruchomienia</dt>
              <dd>
                <span v-bind:class="{'text-success' : instructions.set_conditions === instructions.total_conditions}">
                  {{ instructions.set_conditions }} / {{ instructions.total_conditions}}
                </span>
              </dd>
            </td>
            <td>
              <dt>Akcje</dt>
              <dd>
                <d-button
                  @click.prevent="editInstructions(instructions)"
                  class="my-1 mr-3">
                  <i class="material-icons">edit</i> Edytuj
                </d-button>
                <d-button
                  theme="danger"
                  class="my-1"
                  @click.prevent="removeInstructions(instructions)">
                  <i class="material-icons">delete</i> Usuń
                </d-button>
              </dd>
            </td>
          </tr>
          <tr v-if="!instructionsList.length">
            <td
              colspan="8"
              class="text-info text-center">
              Brak uruchomień do wyświetlenia.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ListUtils from '@/utils/ListUtils.js';
import instructionUtils from '@/utils/instructions'
import SsDate from '@/components/common/SsDate'

export default {
  name: 'InstructionsList',
  components: {
    SsDate
  },
  props: {
    instructionsListProp: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    instructionsListProp: {
      handler: function (to) {
        this.$set(this, 'instructionsList', _.clone(to));
        this.recalculateConditions();
      },
      deep: true
    }
  },
  data () {
    return {
      fetched: true,
      instructionsList: [],
      selected_execute_date: '',
      transfer_types_lang: instructionUtils.transfer_types_lang
    }
  },
  mounted () {
    this.instructionsList = JSON.parse(JSON.stringify((this.instructionsListProp)));
    this.recalculateConditions();
    this.fetched = true;
  },
  methods: {
    editInstructions (instructions) {
      instructions.files_to_delete = [];
      this.$bus.$emit('contract-instructions-form-show', _.clone(instructions));
    },
    toNumber (number) {
      return Vue.toNumber(number);
    },
    removeInstructions (instructions) {
      this.actionInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/api/contract-instructions/delete/' + instructions.id,
        id: null,
        successTitle: 'Uruchomienie dyspozycji zostało usunięte.',
        successText: '',
        confirmTitle: 'Uwaga',
        confirmText: 'Czy potwierdzasz usunięcie uruchomienia?',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie uruchomienia nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.$bus.$emit('contract-reload-instructions');
          this.$bus.$emit('reload-contract');
        },
        failAction: () => {
          this.actionInProgress = false;
        },
        cancelAction: () => {
          this.actionInProgress = false;
        },
      });
    },
    recalculateConditions () {
      for (let i = 0; i < this.instructionsList.length; i++) {
        this.instructionsList[i].total_conditions = 0;
        this.instructionsList[i].set_conditions = 0;
        for (let item of this.instructionsList[i].conditions) {
          this.instructionsList[i].total_conditions += 1;
          if (item.status === 1 || item.status === '1') {
            this.instructionsList[i].set_conditions += 1;
          }
        }
      }
    },
    executeInstruction (index) {
      let instruction_id = this.instructionsList[index].id;
      if (instruction_id > 0) {
        setTimeout(() => {
          axios.post('api/contract-instructions/change-contract-instruction-status', {
            id: instruction_id,
            transfer_execution_date: this.selected_execute_date
          }).then(response => {
            Vue.swal({
              type: 'success',
              title: 'Data realizacji przelewu została zmieniona',
              showConfirmButton: true,
            }).then(() => {
              this.instructionsList[index].transfer_execution_date = this.selected_execute_date;
              this.$bus.$emit('contract-reload-instructions');
              this.$bus.$emit('reload-contract');
            });
          }).catch((errors) => {
            Vue.swal({
              type: 'error',
              title: errors.response.data.message,
              html: Vue.transformErrorsToHtml(errors.response.data.errors),
              showConfirmButton: true,
            });
            console.log(errors);
          })
        })
      }
    }
  }
}
</script>

<style scoped>
.action-cell {
  width: 210px;
}
</style>
